<template>
  <div class="addversion">
    <div class="title">
      版本管理 <span>{{titlename}}版本</span>
    </div>
    <div class="main">
      <div class="addVersionInfo">{{titlename}}版本</div>
      <div class="versionContent">
        <div class="versionlist">
          <label for="appName"><span>*</span>应用名称</label>
          <el-select v-model="appName"
                     size="small">
            <el-option v-for="item in appNameOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="versionlist">
          <label for="version">
            <span>*</span>版本号
          </label>
          <el-input size="small"
                    placeholder=""
                    v-model="versionInfo.version"></el-input>
        </div>
        <div class="versionlist updateTar">
          <label for="tar">
            <div class="tar">上传软件压缩包</div>
            <span class="tarIcon">*</span>
          </label>
          <el-input size="small"
                    v-model="filesName"
                    readonly></el-input>
          <div class="updateFileBtn">选择文件
            <input type="file"
                   name="img"
                   id=""
                   @change="handleFileUpdate"
                   class="updateBtn">
          </div>
        </div>
        <div class="versionlist">
          <label for="mobileType"><span>*</span>移动设备</label>
          <el-select v-model="mobileType"
                     size="small">
            <el-option v-for="item in mobileOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>

          </el-select>
        </div>
        <div class="versionlist">
          <label for="status">
            <span>*</span>更新方式
          </label>
          <el-select v-model="status"
                     size="small">
            <el-option v-for="item in statusOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="versionlist">
          <label for="updateStatus">
            <span>*</span>数据状态
          </label>
          <div class='versionRadio'>
            <el-radio v-model="radio"
                      label="0">正常</el-radio>
            <el-radio v-model="radio"
                      label="1">禁用</el-radio>
          </div>
        </div>
        <div class="versionlist">
          <label for="remark">更新内容</label>
          <el-input type="textarea"
                    :autosize="{ minRows: 3, maxRows: 8}"
                    v-model="versionInfo.remarks"></el-input>
        </div>
        <div class="versionBtn">
          <button class="save"
                  @click="handleAddVersionClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { updateVersion } from 'apis/index'
// import { mapState } from 'vuex'
import axios from 'axios'
export default {
  name: 'addversion',
  data () {
    return {
      titlename: '',
      radio: '0',
      MultipartFile: null,
      filesName: '',
      appName: '',
      appNameOptions: [{
        value: '0',
        label: 'V货帮-货主端'
      }, {
        value: '1',
        label: 'V货帮-物流端'
      }, {
        value: '2',
        label: 'V货帮-车载终端-硬件'
      }, {
        value: '3',
        label: 'V货帮-车载终端-手机'
      }],
      mobileType: '',
      mobileOptions: [{
        value: '0',
        label: 'iOS'
      }, {
        value: '1',
        label: '安卓'
      }, {
        value: '2',
        label: '智能硬件'
      }, {
        value: '3',
        label: '智能硬件手机'
      }],
      status: '',
      statusOptions: [{
        value: '0',
        label: '强制更新'
      }, {
        value: '1',
        label: '选择更新'
      }],
      versionInfo: {
        id: ''
      }
    }
  },
  // computed: mapState({
  //   versionInfo: state => state.version.versionInfo
  // }),
  methods: {
    getData () {
      updateVersion({
        id: this.versionInfo.id
      }).then(res => {
        // console.log(res)
        if (res.data.code === 200) {
          this.versionInfo = res.data.data
          this.appName = String(this.versionInfo.appType)
          this.mobileType = String(this.versionInfo.mobileType)
          this.status = String(this.versionInfo.updateStatus)
          this.radio = String(this.versionInfo.status)
          this.filesName = this.versionInfo.appUrl
        }
      })
    },
    handleAddVersionClick () {
      let appType = this.appName ? this.appName : ''
      let version = this.versionInfo.version ? this.versionInfo.version : ''
      let MultipartFile = this.MultipartFile ? this.MultipartFile : ''
      let mobileType = this.mobileType ? this.mobileType : ''
      let updateStatus = this.status ? this.status : ''
      let status = this.radio
      let remarks = this.versionInfo.remarks ? this.versionInfo.remarks : ''
      if (!appType | !version | !mobileType | !updateStatus | !status) {
        this.$message({
          message: '*为必选内容',
          type: 'warning'
        })
      } else {
        let param = new FormData()
        param.append('appType', Number(appType))
        param.append('version', version)
        param.append('mobileType', Number(mobileType))
        param.append('updateStatus', Number(updateStatus))
        param.append('status', Number(status))
        param.append('remarks', remarks)
        if (this.versionInfo.id) { // 修改
          param.append('id', this.versionInfo.id)
          if (!MultipartFile) { // 不更新app
            axios.post('/api/admin/updateVhbVersion.do', param).then(response => {
              if (response.data.code === 200) {
                this.$router.push({ path: '/manage/version' })
              }
            })
          } else { // 更新app
            param.append('MultipartFile', MultipartFile)
            axios.post('/api/admin/updateVhbVersion.do', param).then(response => {
              if (response.data.code === 200) {
                this.$router.push({ path: '/manage/version' })
              }
            })
          }
        } else { // 保存
          if (!MultipartFile) {
            this.$message({
              message: '*为必选内容',
              type: 'warning'
            })
          } else {
            param.append('MultipartFile', MultipartFile)
            axios.post('/api/admin/addVhbVersion.do', param).then(response => {
              if (response.data.code === 200) {
                this.$router.push({ path: '/manage/version' })
              }
            })
          }
        }
      }
    },
    handleCancelClick () { // 取消添加/修改
      this.$router.push({ path: '/manage/version' })
    },
    handleFileUpdate (e) { // 上传文件
      this.MultipartFile = e.target.files[0]
      this.filesName = this.MultipartFile.name
    }
  },
  mounted () {
    this.versionInfo.id = this.$route.query.item
    if (this.versionInfo.id) {
      this.titlename = '修改'
      this.getData()
      // this.appName = String(this.versionInfo.appType)
      // this.mobileType = String(this.versionInfo.mobileType)
      // this.status = String(this.versionInfo.updateStatus)
      // this.radio = String(this.versionInfo.status)
      // this.filesName = this.versionInfo.appUrl
    }
  }
}
</script>
<style lang="stylus">
.addversion
  width calc(100% - 40px)
  height calc(100% - 20px)
  background #fff
  margin 0 20px
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../assets/images/01/nav_arrow.png') no-repeat top 21px left 57px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    overflow-y auto
    .addVersionInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../assets/images/03/add_icon.png') no-repeat center left 15px
    .versionContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      // border-bottom 1px solid #CFD5DC
      .versionlist
        margin-top 26px
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
          .tar
            width 50px
            height 30px
            float right
            text-align left
            line-height 15px
          .tarIcon
            width 5px
            height 30px
            float right
            line-height 15px
        .el-input
          width 220px
          margin-left 12px
        .el-textarea
          width 475px
          margin-left 12px
        .versionRadio
          height 30px
          .el-radio
            width 80px
            .el-radio__label
              color #212832
      .updateTar
        position relative
        .updateFileBtn
          position absolute
          width 112px
          height 30px
          cursor pointer
          background #00D5B9
          text-align center
          text-indent 2em
          line-height 32px
          left 443px
          top 0px
          border-radius 3px
          background url('../../assets/images/07/wenjian_icon.png') no-repeat center left 20px #00D5B9
          size12()
          color #FFFFFF
          .updateBtn
            position absolute
            top 0px
            left 0px
            cursor pointer
            opacity 0
            right 0px
            bottom 0px
            overflow hidden
      .versionBtn
        margin-left 153px
        margin-top 94px
        margin-bottom 20px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
